export const ReviewSteps = {
  RATE: 'RATE',
  SHARE: 'SHARE',
  ABOUT: 'ABOUT'
};
export const ProfileReviewSteps = {
  RATE: 'RATE',
  ABOUT: 'ABOUT'
};